import React from "react";
import { Link } from "react-router-dom";
import SeoHead from "../components/SeoHead";

const posts = [
  {
    slug: "why-landlords-need-rent-management-software",
    title: "Why Every Kenyan Landlord Needs Rent Management Software in 2026",
    excerpt: "Still using a notebook to track rent? Here's why switching to a digital system saves you money, time, and tenant relationships.",
    date: "2026-03-15",
    category: "Guides",
    readTime: "5 min read",
  },
  {
    slug: "reduce-late-rent-payments",
    title: "5 Proven Ways to Reduce Late Rent Payments",
    excerpt: "Late rent is the biggest headache for landlords. These five strategies, from automated reminders to AI calls, dramatically improve collection rates.",
    date: "2026-03-08",
    category: "Tips",
    readTime: "4 min read",
  },
  {
    slug: "tenant-onboarding-best-practices",
    title: "Tenant Onboarding Best Practices for Property Managers",
    excerpt: "A smooth onboarding process sets the tone for the entire tenancy. Learn how to collect deposits, set expectations, and document everything.",
    date: "2026-02-20",
    category: "Guides",
    readTime: "6 min read",
  },
  {
    slug: "ai-calling-for-rent-collection",
    title: "How AI Voice Agents Are Changing Rent Collection in Kenya",
    excerpt: "AI-powered phone calls can remind tenants about rent without the awkwardness. Here's how Paysafi's AI calling feature works.",
    date: "2026-02-10",
    category: "Product",
    readTime: "3 min read",
  },
  {
    slug: "partial-payments-how-to-handle",
    title: "How to Handle Partial Rent Payments Without Losing Track",
    excerpt: "When a tenant pays half their rent, tracking the balance across months gets messy fast. Here's how Paysafi handles it automatically.",
    date: "2026-01-28",
    category: "Tips",
    readTime: "4 min read",
  },
  {
    slug: "property-management-kenya-guide",
    title: "The Complete Guide to Property Management in Kenya",
    excerpt: "From legal requirements to day to day operations, everything you need to know about managing rental properties in Kenya.",
    date: "2026-01-15",
    category: "Guides",
    readTime: "10 min read",
  },
];

export { posts };

export default function BlogPage() {
  return (
    <article>
      <SeoHead
        title="Blog"
        description="Tips, guides, and insights for landlords and property managers in Kenya, from rent collection strategies to tenant onboarding best practices."
        path="/blog"
      />
      <section className="border-b border-gray-100 dark:border-gray-800 bg-gray-50 dark:bg-gray-900 py-16 sm:py-20">
        <div className="mx-auto max-w-3xl px-4 text-center sm:px-6">
          <h1 className="text-4xl font-bold tracking-tight text-gray-900 dark:text-white sm:text-5xl">
            Blog
          </h1>
          <p className="mt-4 text-lg text-gray-600 dark:text-gray-400">
            Tips, guides, and insights for landlords and property managers in Kenya.
          </p>
        </div>
      </section>
      <section className="py-14 sm:py-20">
        <div className="mx-auto max-w-5xl px-4 sm:px-6">
          <div className="grid gap-8 sm:grid-cols-2 lg:grid-cols-3">
            {posts.map((p) => (
              <Link
                key={p.slug}
                to={`/blog/${p.slug}`}
                className="group flex flex-col rounded-2xl border border-gray-200 dark:border-gray-700 bg-white dark:bg-gray-800 p-6 transition-shadow duration-200 hover:shadow-md"
              >
                <span className="text-xs font-medium text-indigo-600">{p.category}</span>
                <h2 className="mt-2 text-base font-semibold text-gray-900 dark:text-white group-hover:text-indigo-600">
                  {p.title}
                </h2>
                <p className="mt-2 flex-1 text-sm leading-relaxed text-gray-600 dark:text-gray-400">
                  {p.excerpt}
                </p>
                <div className="mt-4 flex items-center gap-2 text-xs text-gray-500">
                  <time>{p.date}</time>
                  <span>·</span>
                  <span>{p.readTime}</span>
                </div>
              </Link>
            ))}
          </div>
        </div>
      </section>
    </article>
  );
}
